"use strict";

exports.__esModule = true;
exports.TimelineSortableField = TimelineSortableField;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _Core = require("../../Core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function TimelineSortableField(props) {
  var setSortable = props.setSortable,
    enableSort = props.enableSort;
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    checked: enableSort,
    label: translate("SortableField.sortable.fieldValue", "Enable Sorting"),
    onChange: function onChange() {
      return setSortable(!enableSort);
    }
  }));
}